var __default__ = {root:'m_a513464',icon:'m_a4ceffb',loader:'m_b0920b15',body:'m_a49ed24',title:'m_3feedf16',description:'m_3d733a3a',closeButton:'m_919a4d88'};
export default __default__;